import { CheckSquare } from "lucide-react";
import { Link } from "react-router-dom";
import type { TaskRow } from "../types";
import {
  Card,
  CardHeader,
  Dot,
  Empty,
  priorityDot,
  relativeDueLabel,
  SkeletonRow,
  ViewAllLink,
} from "./_shared";

type Props = {
  tasks: TaskRow[];
  isLoading?: boolean;
};

export function MyTasksWidget({ tasks, isLoading }: Props) {
  return (
    <Card>
      <CardHeader
        icon={
          <CheckSquare
            className="h-4 w-4 text-[hsl(210,100%,40%)]"
            strokeWidth={1.5}
          />
        }
        title="My Tasks"
        count={tasks.length}
        action={<ViewAllLink href="/tasks?assignedToMe=true" />}
      />
      {isLoading ? (
        <div>
          {[0, 1, 2, 3, 4].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : tasks.length === 0 ? (
        <Empty
          icon={
            <CheckSquare
              className="h-8 w-8 text-muted-foreground opacity-40"
              strokeWidth={1.5}
            />
          }
          text="No open tasks — you're all caught up! 🎉"
          variant="success"
        />
      ) : (
        <ul className="divide-y" style={{ borderColor: "hsl(210,30%,92%)" }}>
          {tasks.slice(0, 5).map((t) => {
            const due = relativeDueLabel(t.dueDate);
            return (
              <li key={t.id}>
                <Link
                  to={`/tasks/${t.id}`}
                  className="flex items-center gap-2 py-2 hover:bg-[hsl(210,50%,98%)]"
                >
                  <Dot color={priorityDot(t.priority)} />
                  <span className="truncate text-[13px] font-medium text-foreground">
                    {t.title}
                  </span>
                  <span className="ml-auto flex shrink-0 items-center gap-1.5 text-[11px]">
                    {due.pill && (
                      <span
                        className="rounded-full px-1.5 py-0.5 text-[10px] font-semibold"
                        style={{
                          background: "hsl(0,70%,94%)",
                          color: "hsl(0,70%,40%)",
                        }}
                      >
                        {due.pill}
                      </span>
                    )}
                    <span style={{ color: due.color }}>{due.text}</span>
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
